import { Col } from 'antd'
import dayjs from 'dayjs'

import { EpidemiologyCaseForm058E_SymptomsSection } from 'src/api/requests'
import { Text } from 'src/components'
import { dayMonthYearFormatWithDot } from 'src/libs'
import { useLocales } from 'src/locales'

type Props = {
  symptoms: EpidemiologyCaseForm058E_SymptomsSection
}
export const NeurologicalSymptomsDetailsCard = ({ symptoms }: Props) => {
  const { t } = useLocales()

  const palsiesParalysisLabel = t(
    'epidemiology.symptoms.neurological.palsiesParalysis'
  )
  const muscleContracturesLabel = t(
    'epidemiology.symptoms.neurological.muscleContractures'
  )
  const appearanceDateLabel = t('epidemiology.symptoms.appearanceDate')

  return (
    <>
      <Col span={24}>
        <Text>
          {`3. ${t('epidemiology.neurological')}`}:{' '}
          <Text weight={400}>
            {t(
              `epidemiology.symptoms.general.${symptoms.neurological?.status}`
            )}
          </Text>
        </Text>
      </Col>

      {symptoms.neurological?.status === 'yes' && (
        <>
          {symptoms.neurological.consciousnessDisorders?.isSelected && (
            <Col span={8}>
              <Text>
                {t('epidemiology.symptoms.neurological.consciousnessDisorders')}
              </Text>
            </Col>
          )}

          {symptoms.neurological.meningealSigns?.isSelected && (
            <Col span={8}>
              <Text>
                {t('epidemiology.symptoms.neurological.meningealSigns')}
              </Text>
            </Col>
          )}

          {symptoms.neurological.convulsionsInvoluntaryMovements
            ?.isSelected && (
            <Col span={8}>
              <Text>
                {t(
                  'epidemiology.symptoms.neurological.convulsionsInvoluntaryMovements'
                )}
              </Text>
            </Col>
          )}

          {symptoms.neurological.hydrophobia?.isSelected && (
            <Col span={8}>
              <Text>{t('epidemiology.symptoms.neurological.hydrophobia')}</Text>
            </Col>
          )}

          {symptoms.neurological?.palsiesParalysis?.isSelected && (
            <>
              <Col span={8}>
                <Text>
                  {palsiesParalysisLabel}

                  {symptoms.neurological.palsiesParalysis.appearanceDate
                    ?.value && (
                    <>
                      {' - '}
                      <Text weight={400}>
                        {appearanceDateLabel}:{' '}
                        {dayjs(
                          symptoms.neurological.palsiesParalysis.appearanceDate
                            .value
                        ).format(dayMonthYearFormatWithDot)}
                      </Text>
                    </>
                  )}
                </Text>
              </Col>

              {symptoms.neurological.palsiesParalysis.acute?.isSelected && (
                <Col span={8}>
                  <Text>
                    {palsiesParalysisLabel} -{' '}
                    {t('epidemiology.symptoms.neurological.acute')}
                  </Text>
                </Col>
              )}

              {symptoms.neurological.palsiesParalysis.flaccid?.isSelected && (
                <Col span={8}>
                  <Text>
                    {palsiesParalysisLabel} -{' '}
                    {t('epidemiology.symptoms.neurological.flaccid')}
                  </Text>
                </Col>
              )}

              {symptoms.neurological.palsiesParalysis.spastic?.isSelected && (
                <Col span={8}>
                  <Text>
                    {palsiesParalysisLabel} -{' '}
                    {t('epidemiology.symptoms.neurological.spastic')}
                  </Text>
                </Col>
              )}

              {symptoms.neurological.palsiesParalysis.limbParalysis
                ?.isSelected && (
                <Col span={8}>
                  <Text>
                    {palsiesParalysisLabel} -{' '}
                    {t('epidemiology.symptoms.neurological.limbParalysis')}
                  </Text>
                </Col>
              )}

              {symptoms.neurological.palsiesParalysis.facialParalysis
                ?.isSelected && (
                <Col span={8}>
                  <Text>
                    {palsiesParalysisLabel} -{' '}
                    {t('epidemiology.symptoms.neurological.facialParalysis')}
                  </Text>
                </Col>
              )}

              {symptoms.neurological.palsiesParalysis.trunkParalysis
                ?.isSelected && (
                <Col span={8}>
                  <Text>
                    {palsiesParalysisLabel} -{' '}
                    {t('epidemiology.symptoms.neurological.trunkParalysis')}
                  </Text>
                </Col>
              )}

              {symptoms.neurological.palsiesParalysis.symmetric?.isSelected && (
                <Col span={8}>
                  <Text>
                    {palsiesParalysisLabel} -{' '}
                    {t('epidemiology.symptoms.neurological.symmetric')}
                  </Text>
                </Col>
              )}

              {symptoms.neurological.palsiesParalysis.asymmetric
                ?.isSelected && (
                <Col span={8}>
                  <Text>
                    {palsiesParalysisLabel} -{' '}
                    {t('epidemiology.symptoms.neurological.asymmetric')}
                  </Text>
                </Col>
              )}
            </>
          )}

          {symptoms.neurological.muscleContractures?.isSelected && (
            <>
              <Col span={8}>
                <Text>{muscleContracturesLabel}</Text>
              </Col>

              {symptoms.neurological.muscleContractures.trism?.isSelected && (
                <Col span={8}>
                  <Text>
                    {muscleContracturesLabel} -{' '}
                    {t('epidemiology.symptoms.neurological.trism')}
                  </Text>
                </Col>
              )}

              {symptoms.neurological.muscleContractures.neckRigidity
                ?.isSelected && (
                <Col span={8}>
                  <Text>
                    {muscleContracturesLabel} -{' '}
                    {t('epidemiology.symptoms.neurological.neckRigidity')}
                  </Text>
                </Col>
              )}

              {symptoms.neurological.muscleContractures.trunkMuscles
                ?.isSelected && (
                <Col span={8}>
                  <Text>
                    {muscleContracturesLabel} -{' '}
                    {t('epidemiology.symptoms.neurological.trunkMuscles')}
                  </Text>
                </Col>
              )}

              {symptoms.neurological.muscleContractures.limbMuscles
                ?.isSelected && (
                <Col span={8}>
                  <Text>
                    {muscleContracturesLabel} -{' '}
                    {t('epidemiology.symptoms.neurological.limbMuscles')}
                  </Text>
                </Col>
              )}
            </>
          )}
        </>
      )}
    </>
  )
}
